import "../src/global/global-mobile"
import "@modules/_components/HTMLDynamicListElement"

import "@modules/browser-extension/open-with-gesamt-icons.css"

// TODO consider layout shift as these files are build out separately and loaded after initial render
import "@modules/location/LocationSelector"
import "@modules/solads/solads"
import "@modules/vue-modals/ad-free.js"
import "@modules/vue-modals/coins"
import "@modules/vue-modals/age-verification.js"

import "@modules/banner/donnerstag/header-donnerstag-mobile.css"
import "@modules/banner/donnerstag/footer-donnerstag-mobile.css"
import "@modules/banner/mittwoch/header-mittwoch-mobile.css"
import "@modules/banner/mittwoch/footer-mittwoch-mobile.css"
import "@modules/single-page/mobile.css"
import "@modules/single-page/gallery/gallery.css"
import "@modules/bookmarks/advert-page/bookmark-tags.css"
import "@modules/single-page/single-page-mobile.css"
import "@modules/advert-cards/advert-card-styles"
import "@modules/single-page/cluster-persons.css"
import "@modules/single-page/crawler-protection/crawler-protection-mobile.css"
import "@modules/single-page/single-page.js"
import "@modules/stars/stars-post"
import "@modules/stars/styles.css"
import "@modules/stars/stars-single-view-feedback.ts"
import "@modules/tracking/previous-next-advert-cookie"
import "@modules/util/Scrolling.ts"
import "@modules/../src/captcha/friendly-captcha.js"
import "@modules/../src/banner/muenchen/muenchen-auto-messe-mobile.css"
import { setAZMFilterPath } from "@modules/global/filter-path/filter-path-handler.ts"
import StarsPost from "@modules/stars/stars-post/StarsPost"
import "@modules/util/LiveCharacterCounter"

setAZMFilterPath()
const posts = new StarsPost(this)

posts.loadCurrentStarsPostsFilterForStarsProfile()
